import { AlpineComponent } from 'alpinejs';
import { AnalyticInterface } from '@/components/analytic/analytic'; 
 

export interface CustomerFormRedirectInterface {
  src: string;
  target: string;
  redirection(event: Event): void;
}

const CustomerFormRedirect = ({
  src,
  target,
}: {
  src: string;
  target: string;
}): AlpineComponent<CustomerFormRedirectInterface> => ({
  target: target ? target : '_self',
  src: src,
  redirection(event: Event): void {
    let request_type: HTMLSelectElement | null = document.querySelector('[name="'+this.src+'"]');
    if(request_type){
      window.open(request_type?.options[request_type?.selectedIndex].value, this.target);
    }
    (<AnalyticInterface>this.$store.analytic).handleFormListener(event);
  },
})

export default CustomerFormRedirect;